import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@99designs/react-components/components/Button';
import Icon from '@99designs/react-components/components/Icon';
import { PopoverCard } from '@99designs/react-components/components/PopoverCard';
import { FormattedMessage } from 'react-intl';

import { connectToStores } from 'fluxible-addons-react';
import LanguageStore from 'contest/stores/language-store';

export class CommentSuggestionsInfoButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
        };
        this.toggle = this.toggle.bind(this);
        this.clear = this.clear.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.clear);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.clear);
    }

    clear() {
        if (this.state.active) {
            this.setState({ active: false });
        }
    }

    toggle(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();

        this.setState({
            active: !this.state.active,
        });
    }

    card() {
        return (
            <div>
                <div>
                    <h5 className="heading heading--h5">
                        <FormattedMessage id="suggested_text_help_what" />
                    </h5>
                    <p
                        className={
                            'paragraph ' +
                            (this.props.language == 'en' ? ' paragraph--no-margin' : '')
                        }
                    >
                        <FormattedMessage id="suggested_text_help_what_info" />
                    </p>
                </div>

                {this.props.language != 'en' && (
                    <div>
                        <h5 className="heading heading--h5">
                            <FormattedMessage id="suggested_text_help_english" />
                        </h5>
                        <p className="paragraph paragraph--no-margin">
                            <FormattedMessage id="suggested_text_help_english_info" />
                        </p>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const button = (
            <Button
                variations={['link-info']}
                onClick={this.toggle}
                icon={<Icon variations={['info-1']} />}
                iconAlignment="left"
            >
                <FormattedMessage id="suggested_text_help_link" />
            </Button>
        );

        if (this.state.active) {
            return (
                <PopoverCard
                    layerSelector="#modal-overlay-layer"
                    variations={['with-padding']}
                    card={this.card()}
                >
                    {button}
                </PopoverCard>
            );
        } else {
            return button;
        }
    }
}

CommentSuggestionsInfoButton.propTypes = {
    language: PropTypes.string.isRequired,
};

export default connectToStores(CommentSuggestionsInfoButton, [LanguageStore], ctx => {
    return {
        language: ctx.getStore(LanguageStore).getLanguage(),
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/comment-suggestions-info-button.jsx